import {cellStylePercentage} from "./Utils";

export const GridColor = {
    RED:'salmon',
    BLUE:'lightblue',
    GREEN:'#02CE66',
    GREY:'#E0E0E0',
    DARK_GREY:'darkgrey',
    ORANGE:'#FF9F4C',
    LIGHTEST_BLUE: '#E5EBFC',
    WHITE:'white',
    TEAL:'#1b8282',
    SKY_BLUE:'#59b9e3',
    LIGHT_BLUE:'#00A2E8',
    DARK_BLUE:'#4619e8',
    PINK:'#FFAFC2',
    BRIGHT_PINK:'#FF6385',
    PURPLE:'#9C64DE',
    DARK_PURPLE:'#420a82'
}

export const ChartLineColor = {
    AVERAGE_TIME_LINE: GridColor.TEAL,
    AVERAGE_GROWTH_LINE: GridColor.LIGHT_BLUE,
    AVERAGE_SCORE_LINE: GridColor.ORANGE,
    POST_TEST:GridColor.DARK_PURPLE,
    PRE_TEST:GridColor.SKY_BLUE,
    POST_TEST_BORDER:'#8243CD',
    INCLINE:GridColor.LIGHT_BLUE,
    INCLINE_BORDER:GridColor.LIGHT_BLUE,
    DECLINE:'#CC0000',
    DECLINE_BORDER:'#CC0000',
    DEFAULT:GridColor.TEAL,
    MEAN:GridColor.ORANGE,
    MEAN_BORDER:GridColor.ORANGE,
    UNANSWERED:'#D1D1D0',
    STAGNANT:'#999',
    STAGNANT_BORDER:'#999'
}

export const MarkColor = {
    mark80to100:'#99c140',
    mark60to79:'#e7b416',
    mark30to59:'#db7b2b',
    mark0to29:'#cc3232',
    CORRECT:'#99c140',
    INCORRECT:'#cc3232',
    DO_NOT_KNOW:'#93CAED',
    SKIPPED:'#cccccc',
    UNANSWERED:'#ffffff'
}

export const MarkFontColor = {
    mark80to100:'#000',
    mark60to79:'#000',
    mark30to59:'#fff',
    mark0to29:'#fff',
    CORRECT:'#000',
    INCORRECT:'#fff',
    DO_NOT_KNOW:'#fff',
    SKIPPED:'#666'
}

export const GridStyle = {
    QUESTIONS_HEADER_HEIGHT: 60,
    VERTICAL_HEADER_HEIGHT: 120,
    AGGREGATE_HEADER_HEIGHT: 60,
    ASSIGN_SKILLS_HEADER_HEIGHT:{
        SKILL_HEIGHT: 68,
        CONCEPT_HEIGHT: 78,
    },
    VERTICAL_HEADER_OFFSET: 72,
    HIGHLIGHT_COLOR: GridColor.LIGHTEST_BLUE,
    GRID_PADDING: 20,
    HORIZONTAL_SCROLLBAR_PADDING: navigator.userAgent.indexOf("Firefox") !== -1 ? 17 : 10, //adjust size for firefox
    GRID_PADDING_SML: 4
}

export const defaultPDFParams = {
    PDF_HEADER_COLOR: '#f8f8f8',
    PDF_INNER_BORDER_COLOR: '#dde2eb',
    PDF_OUTER_BORDER_COLOR: '#babfc7',
    PDF_LOGO: '',
    PDF_WITH_HEADER_IMAGE: false,
    PDF_PAGE_ORIENTATION: 'landscape',
    PDF_WITH_FOOTER_PAGE_COUNT: true,
    PDF_HEADER_HEIGHT: 50,
    PDF_ROW_HEIGHT: 37,
    PDF_ODD_BKG_COLOR: GridColor.WHITE,
    PDF_EVEN_BKG_COLOR: GridColor.LIGHTEST_BLUE,
    PDF_WITH_CELL_FORMATTING: true,
    PDF_WITH_COLUMNS_AS_LINKS: false,
    PDF_SELECTED_ROWS_ONLY: false,
    PDF_COLUMN_WIDTH: 45
}

export const COL_WIDTH = {
    THIN:40,
    QUESTION:46,
    RESULT:52,
    NARROW:80,
    MEDIUM:120,
    BIG:170,
    BIGGER:220
}

export const FB_MESSAGES = {
    SELECT_DIAGNOSTIC_TEST_MESSAGE: 'Please select a test.',
    SELECT_STANDARD_TEST_MESSAGE: 'Please select a test.',
    STANDARD_TEST_NO_ASSIGNMENTS_MESSAGE: 'No test assignments for this class.',
    SELECT_STANDARD_TEST_GROUP_MESSAGE: 'Please select a test family.',
    GENERATE_REPORT_MESSAGE: 'Generate report to continue.',
    NO_TEST_ASSIGNMENTS_FOR_TEST_FAMILY_MESSAGE: 'No test assignments for this test family.',
    SELECT_TEST_ASSIGNMENTS_MESSAGE: 'Please select test assignment/s.',
    SELECT_CLASS_TEST_MESSAGE: 'Please select a class.',
    SELECT_STUDENT_TEST_MESSAGE: 'Please select a student from this class to see any results.',
    SELECT_STUDENT_TEST_GROUP_MESSAGE: 'Please select a student to see results.',
    NO_STUDENTS_IN_CLASS: 'No students are in this class.',
    SELECT_TOPIC_TEST_MESSAGE: 'Please select a chapter.',
    PRE_TEST_NOT_ASSIGNED: 'Pre test has not been assigned.',
    POST_TEST_NOT_ASSIGNED: 'Post test has not been assigned.',
    TESTS_NOT_ASSIGNED: 'No tests have been assigned.',
    NO_STUDENT_RESULTS_DATA: 'No student results have been recorded for ',
    NO_STUDENT_RESULTS_DATA_NO_TEST: 'No student results have been recorded.',
    NO_STUDENT_RESULTS_FOR_COMPARISON: 'Not enough student result data for comparison.',
    MOST_RECENT_ONLY: 'Showing most recent only results for '
}

export const GRID_ENUMS = {
    ASC: 1,
    DESC: 2,
    TEST_TOTAL: 'testTotal',
    DIFFICULTY: 'difficulty',
    TEST_AMOUNT: 'testAmount',
    TEST_TOTAL_VALUE: 'testTotalValue',
    CORRECT_PERCENT: 'correctPercent',
    CORRECT_PERCENT_VALUE: 'correctPercentValue',
    CORRECT_PERCENT_STUDENT: 'TOTAL',
    PERFORMANCE: 'performance',
    PERFORMANCE_PRE: 'performancePre',
    PERFORMANCE_POST: 'performancePost',
    USER: 'user',
    CONTENT: 'content',
    QUESTION: 'Question',
    TEST_ASSIGNMENT: 'testAssignment',
    NOT_AVAILABLE: 'n/a',
    NOT_ATTEMPTED: 'not attempted',
    ALL_ANSWERED_PERCENT: 'allAnsweredPercent',
    ALL_ANSWERED_PERCENT_VALUE: 'allAnsweredPercentValue',
    NAME_ASC: 'NAME_ASC',
    NAME_DESC: 'NAME_DESC',
    LOWEST: 'LOWEST',
    LOWEST_PRE: 'LOWEST_PRE',
    LOWEST_POST: 'LOWEST_POST',
    HIGHEST: 'HIGHEST',
    HIGHEST_PRE: 'HIGHEST_PRE',
    HIGHEST_POST: 'HIGHEST_POST',
    CURRICULUM: 'curriculum',
    TEXT: 'text',
    EXAM: 'exam',
    ALPHABETICAL: 'alphabetical',
    DISTANCE_FROM_AVERAGE_PRE: 'distanceFromAveragePre',
    DISTANCE_FROM_AVERAGE_POST: 'distanceFromAveragePost',
    GROWTH_GREATEST: 'GROWTH_GREATEST',
    GROWTH_LEAST: 'GROWTH_LEAST',
}

export const COMPARISON_TYPE = {
    CURRICULUM: {val:0, display:'curriculum', properDisplay:'Curriculum',  upperDisplay:'CURRICULUM'},
    TEXT: {val:1, display:'text', properDisplay:'Text', upperDisplay:'TEXT'}
}

export const AGGREGATE_LEVELS = {
    SYLLABUS:'syllabus',
    TOPIC:'topic',
    CONCEPT:'concept',
    STRAND: 'strand',
    SUBSTRAND: 'substrand',
    SKILL:'skill'
};

export const AGGREGATE_LEVEL_DEPTH = {
    syllabus:1,
    topic:2,
    concept:3,
    skill:4
};

const questionCol = {field:"questionTitle",headerName:"Question #"},
    difficultyCol = {field:"difficulty",headerName:"Difficulty"},
    studentCol = {field:"studentName",headerName:"Student name"};

export const COL_DEFS = {
    defaultColDef: {
        suppressMovable: true,
        resizable:true,
        cellDataType: 'text'
    },
    correctColDef:{
        pdfExportOptions: {
            styles:{alignment: 'center'}
        },
        width:COL_WIDTH.NARROW+20,
        headerName:'% correct',
        field:GRID_ENUMS.CORRECT_PERCENT,
        // headerClass:'',
        cellStyle:cellStylePercentage,
        pinned:'right',
        pinnedOrder: 0,
        sortable: true,
        unSortIcon: true,
        comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
            const valA = nodeA.data[GRID_ENUMS.CORRECT_PERCENT_VALUE],
                valB = nodeB.data[GRID_ENUMS.CORRECT_PERCENT_VALUE];
            if (valA === valB){
                return 0 ;
            }else{
                return (valA > valB) ? 1 : -1;
            }
        }
    },
    totalMarkColDef:{
        pdfExportOptions: {
            styles:{alignment: 'center'}
        },
        width:COL_WIDTH.NARROW+20,
        headerName:'TOTAL',
        field:GRID_ENUMS.TEST_TOTAL,
        headerClass:'left-26',
        cellStyle:cellStylePercentage,
        pinned:'right',
        pinnedOrder: 0,
        sortable: true,
        unSortIcon: true,
        comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
            const valA = nodeA.data[GRID_ENUMS.TEST_TOTAL],
                valB = nodeB.data[GRID_ENUMS.TEST_TOTAL];
            if (valA === valB){
                return 0 ;
            }else{
                return (valA > valB) ? 1 : -1;
            }
        }
    },
    answerColDef:{
        pdfExportOptions: {
            styles:{alignment: 'center'}
        },
        width: COL_WIDTH.MEDIUM+30,
        headerName: '% of All Answered',
        field: GRID_ENUMS.ALL_ANSWERED_PERCENT,
        // headerClass: 'text-center-align',
        cellStyle: cellStylePercentage,
        pinned: 'right',
        pinnedOrder: 1,
        sortable: true,
        unSortIcon: true,
        comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
            const valA = nodeA.data[GRID_ENUMS.ALL_ANSWERED_PERCENT_VALUE],
                valB = nodeB.data[GRID_ENUMS.ALL_ANSWERED_PERCENT_VALUE];
            if (valA === valB){
                return 0 ;
            }else{
                return (valA > valB) ? 1 : -1;
            }
        }
    },
    questionColDef: {
        headerClass: 'text-center-align margin-top-40',
        headerStyle: {marginTop:'40px'},
        cellStyle: {textAlign:'center',borderRight:'1px solid lightgrey'},
        width: 150,
        field: questionCol.field,
        headerName: questionCol.headerName,
        pinned: 'left',
        pinnedOrder: 0
    },
    studentColDef: {
        headerClass: 'text-center-align',
        headerStyle: {marginTop:'40px'},
        cellStyle: {textAlign:'center',borderRight:'1px solid lightgrey'},
        width: 150,
        field: studentCol.field,
        headerName: studentCol.headerName,
        pinned: 'left',
        pinnedOrder: 0
    },
    difficultyColDef: {
        pdfExportOptions: {styles:{alignment: 'center'}},
        headerClass: 'text-center-align vertical-align-heading unset-whitespace',
        cellStyle: {textAlign:'center'},
        headerStyle: {whiteSpace:'unset'},
        width: COL_WIDTH.THIN,
        field: difficultyCol.field,
        headerName: difficultyCol.headerName,
        pinned: 'left',
        pinnedOrder: 1
    },
}
